'use client'
import Link from 'next/link'
import { useSearchParams } from 'next/navigation'

type Props = Parameters<typeof Link>[0]

export default function LinkWithQuery({ children, href, ...props }: Props) {
  const searchParams = useSearchParams()

  const [hrefPath, hrefQuery] = href.toString().split('?')

  const mergedParams = new URLSearchParams(hrefQuery ?? '')
  searchParams.forEach((value, key) => {
    if (!mergedParams.has(key)) {
      mergedParams.set(key, value)
    }
  })

  const queryString = mergedParams.toString()
  const mergedHref = `${hrefPath}${queryString ? `?${queryString}` : ''}`

  return (
    <Link href={mergedHref} {...props}>
      {children}
    </Link>
  )
}
